export default __webpack_public_path__ + "static/media/flower-etf.5cc93125.png";